/**
 * Cart Gift Manager
 * Automatically adds/removes a free gift product when alcohol is in the cart.
 * Reads state from a Liquid-rendered JSON element (#cart-gift-data) that is
 * refreshed on every cart drawer re-render via the sections API.
 *
 * If the customer declines the gift (clicks X), we store that in sessionStorage
 * so it won't be re-added during their browsing session. Clearing the cart
 * or starting a new session resets the decline.
 */
(function () {
  var DECLINED_KEY = 'cart_gift_declined';
  var isProcessing = false;

  function isGiftDeclined() {
    try { return sessionStorage.getItem(DECLINED_KEY) === 'true'; } catch (e) { return false; }
  }

  function setGiftDeclined(val) {
    try { sessionStorage.setItem(DECLINED_KEY, val ? 'true' : 'false'); } catch (e) { /* silent */ }
  }

  function getGiftData() {
    var el = document.getElementById('cart-gift-data');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function updateDrawerFromSections(sections) {
    var cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    ['cart-drawer', 'cart-icon-bubble'].forEach(function (sectionId) {
      if (!sections[sectionId]) return;
      var html = new DOMParser().parseFromString(sections[sectionId], 'text/html');

      if (sectionId === 'cart-drawer') {
        var source = html.querySelector('.drawer__inner');
        var target = document.querySelector('#CartDrawer .drawer__inner') || document.querySelector('.drawer__inner');
        if (source && target) target.innerHTML = source.innerHTML;

        var overlay = document.getElementById('CartDrawer-Overlay');
        if (overlay) overlay.addEventListener('click', function () { cartDrawer.close(); });
      } else {
        var source = html.querySelector('.shopify-section');
        var target = document.getElementById(sectionId);
        if (source && target) target.innerHTML = source.innerHTML;
      }
    });
  }

  function addGift(giftVariantId) {
    if (isProcessing) return;
    isProcessing = true;

    var body = JSON.stringify({
      items: [{
        id: giftVariantId,
        quantity: 1,
        properties: { _gift: 'true' }
      }],
      sections: 'cart-drawer,cart-icon-bubble',
      sections_url: window.location.pathname
    });

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/javascript'
      },
      body: body
    })
      .then(function (res) { return res.json(); })
      .then(function (response) {
        if (response.status) return;
        if (response.sections) {
          updateDrawerFromSections(response.sections);
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-manager',
          cartData: response
        });
      })
      .catch(function () { /* silent */ })
      .finally(function () { isProcessing = false; });
  }

  function removeGift() {
    if (isProcessing) return;
    isProcessing = true;

    fetch(window.routes.cart_url + '.js', {
      method: 'GET',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var giftLine = null;
        for (var i = 0; i < cart.items.length; i++) {
          if (cart.items[i].properties && cart.items[i].properties._gift === 'true') {
            giftLine = i + 1;
            break;
          }
        }
        if (!giftLine) {
          isProcessing = false;
          return;
        }

        var body = JSON.stringify({
          line: giftLine,
          quantity: 0,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: window.location.pathname
        });

        return fetch(window.routes.cart_change_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/javascript'
          },
          body: body
        });
      })
      .then(function (res) { return res ? res.json() : null; })
      .then(function (response) {
        if (!response) return;
        if (response.sections) {
          updateDrawerFromSections(response.sections);
        }
        var cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && response.item_count === 0) {
          cartDrawer.classList.add('is-empty');
        }
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-gift-manager',
          cartData: response
        });
      })
      .catch(function () { /* silent */ })
      .finally(function () { isProcessing = false; });
  }

  // Listen for clicks on the gift decline/remove button
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-gift-declined]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    setGiftDeclined(true);
    // The cart-remove-button custom element will handle the actual removal
    // via its own click handler. We just need to mark it as declined.
  });

  function resolveVariantId(data, callback) {
    // If Liquid provided the variant ID, use it directly
    if (data.giftVariantId) {
      callback(data.giftVariantId);
      return;
    }
    // Otherwise fetch the product JSON to get the first variant ID
    if (!data.giftProductHandle) return;
    fetch('/products/' + data.giftProductHandle + '.js')
      .then(function (res) { return res.json(); })
      .then(function (product) {
        if (product.variants && product.variants[0]) {
          callback(product.variants[0].id);
        }
      })
      .catch(function () { /* silent */ });
  }

  function checkAndManageGift(event) {
    if (event && event.source === 'cart-gift-manager') return;
    if (isProcessing) return;

    setTimeout(function () {
      var data = getGiftData();
      if (!data) return;
      if (!data.enabled) {
        if (data.giftInCart) removeGift();
        return;
      }

      // If no alcohol in cart, reset the declined state for next time
      if (!data.hasAlcohol) {
        setGiftDeclined(false);
        if (data.giftInCart) {
          removeGift();
        }
        return;
      }

      // If customer declined the gift, don't re-add it
      if (isGiftDeclined()) return;

      if (data.hasAlcohol && !data.giftInCart) {
        resolveVariantId(data, function (variantId) {
          addGift(variantId);
        });
      }
    }, 100);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, checkAndManageGift);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { checkAndManageGift({}); });
  } else {
    checkAndManageGift({});
  }
})();
